module.exports = __webpack_public_path__ + "static/media/ks_qPCR_obtained.66c94dbc.png";